'use strict';

const React = require('react/addons'),
    {t} = require('services/i18nextWrapper'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    SessionStore = require('stores/SessionStore'),
    BeerStyleStore = require('stores/BeerStyleStore'),
    IconStore = require('stores/IconStore'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    Loading = require('components/Commons/Loading/Loading'),
    NumberUtils = require('utils/NumberUtils'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupColorPicker = require('components/Commons/BasicForm/FormGroupColorPicker/FormGroupColorPicker'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    FormGroupToggle = require('components/Commons/BasicForm/FormGroupToggle/FormGroupToggle'),
    Stamps = require('components/Commons/Stamps/Stamps'),
    Stamp = require('components/Commons/Stamps/Stamp/Stamp'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    Authentication = require('services/Security').Authentication,
    ContentUtils = require('utils/ContentUtils'),
    get = require('lodash/object').get,
    {find, map, filter} = require('lodash/collection'),
    {Navigation} = require('react-router'),
    Notification = require('components/Notification/Notification'),
    {
        FERMENTER_TYPE_TASK,
        PACKAGING_TYPE_TASK,
        BREWING_TYPE_TASK
    } = require('constants/AppConstants'),
    _ = require('lodash'),
    ga = require('react-ga');


const BeerStyleAdmin = React.createClass({displayName: "BeerStyleAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedItem: null,
            isSaving: false
        };
    },

    componentDidMount() {
        this.fetchBeerStyles();
        ga.pageview('/style-beer-admin');
    },

    fetchBeerStyles() {
        const self = this;
        IconStore.fetchIcons(icons => {
            const dirtyIcons = get(icons, 'icons', []);
            const cleanIcons = map(dirtyIcons, icon => icon.iconDetail);
            BeerStyleStore.fetchStyleBeers(function (beerStyles) {
                self.setState({
                    beerStyles: self._hydrateBeerStyleWithIcons(beerStyles, cleanIcons)
                }); 
            });
        });
    },

    _hydrateBeerStyleWithIcons(beerStyles, icons) {
        for (let beerStyle of beerStyles) {
            const configurations = get(
                beerStyle,
                'styleBeerConfigurationTaskDto'
            );
            if (ContentUtils.isNotEmptyArray(configurations)) {
                for (const configuration of configurations) {

                    const iconTarget = DashboardServiceCache.hydrateWithIcon(
                         configuration,
                         'typeTask',
                         'admin',
                         icons
                     ).icon;

                    if (iconTarget) {
                        configuration.icon = iconTarget;
                    }
                }

                const configurationsSorted = _.sortBy(configurations, 'day');
                beerStyle = _.set(
                    beerStyle,
                    'styleBeerConfigurationTaskDto',
                    configurationsSorted
                );
            }
        }

        return beerStyles;
    },

    _onDeleteBeerStyle(tank, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('beer_style_confirm_delete'),
            () => {
                BeerStyleStore.deleteStyleBeer(tank, onSuccess, onFailure);
            }
        );
    },

    _getBreadcrumbLinks() {
        return [
            {
                displayName: t('beer_style_label_name')
            }
        ];
    },

    _onChangeBeerStyle(tank, onSuccess, onFailure) {
        BeerStyleStore.changeStyleBeer(tank, onSuccess, onFailure);
    },

    _onAddBeerStyle(tank, onSuccess, onFailure) {
        BeerStyleStore.addNewStyleBeer(tank, onSuccess, onFailure);
    },

    _onRowSelection(item,
                    itemIndex,
                    lastRowScrollPosition,
                    headerActiveFilters) {
        this.setState(
            prevState => {
                return {
                    selectedItem: item,
                    isEditMode: !prevState.isEditMode,
                    headerActiveFilters
                };
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset is outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onCancel() {
        this.setState({
            selectedItem: null
        });
    },

    _getWrapperColor(beerStyle) {
        return (
            React.createElement("div", null, 
                React.createElement("span", {
                    className: "text-center", 
                    style: {
                        height: '20px',
                        borderRadius: '22px',
                        boxShadow: '1px 2px 4px 0px gray',
                        backgroundColor: get(beerStyle, 'color'),
                        border: 'solid 0px black',
                        padding: '10px 17px',
                        left: '0',
                        position: 'relative',
                        opacity: '.6'
                    }}
                ), 
                React.createElement("span", {style: {paddingLeft: '10px'}}, get(beerStyle, 'name'))
            )
        );
    },

    _goToSelectedBeerStyle(type = 'brewing') {
        this.transitionTo(
            '/styleBeer/:styleBeerId/tasks',
            {
                styleBeerId: get(this.state, 'selectedItem.id')
            },
            {
                type,
                packagingDays: get(this.state, 'selectedItem.packagingDays'),
                fermenterDays: get(this.state, 'selectedItem.fermenterDays'),
                beerStyleName: get(this.state, 'selectedItem.name')
            }
        );
    },

    _getStampsIcons(type, stamps) {
        const filteredStamps = filter(
            stamps,
            stamp => get(stamp, 'typeTank') === type
        );

        return (
            React.createElement(Stamps, null, 
                map(filteredStamps, stamp => {
                    const iconClassName = `icon-task ${get(stamp, 'icon.iconClassName')}`;
                    return (React.createElement(Stamp, {
                        text: get(stamp, 'day'), 
                        classNameIcon: iconClassName}
                    ));
                })
            )
        );
    },

    _onDuplicate(contextHolder) {
        // get value from all fields
        let currentSelectedItem = contextHolder.getItem();

        // override with duplicate label
        currentSelectedItem.name = ContentUtils.formatDuplicateName(currentSelectedItem.name);

        // add date to duplicate and remove id in order
        // to generate a new one like new item
        currentSelectedItem.duplicatedId = get(this.state, 'selectedItem.id');
        currentSelectedItem.id = null;
        currentSelectedItem.isDuplicated = true;

        this._onAddBeerStyle(currentSelectedItem, () => {
            Notification.show(t('beer_style_duplicated_success'), 'success');
            this.fetchBeerStyles();
        });
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    render() {
        if (!this.state.beerStyles) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('beer_style_admin_change_message_success'),
                changeFailureMessage: t('beer_style_admin_change_message_failure'),
                deleteSuccessMessage: t('beer_style_admin_delete_message_success'),
                addSuccessMessage: t('beer_style_admin_add_message_success'),
                addFailureMessage: t('beer_style_admin_add_message_failure')
            };
            let contextHolder = this.getContextHolderInstance();
            let {selectedItem, beerStyles, headerActiveFilters, isSaving} = this.state;

            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "name", 
                    name: t('beer_style_label_name'), 
                    value: selectedItem, 
                    label: t('beer_style_label_name_named'), 
                    onEnter: this._onEnterPress}

                ),
                React.createElement(FormGroupColorPicker, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "color", 
                    name: t('beer_style_color'), 
                    value: selectedItem, 
                    label: t('beer_style_color'), 
                    isRequired: true}
                ),
                React.createElement(FormGroupTextfield, {
                    additionalValidation: value =>
                        NumberUtils.isNumber(value) && value > 0
                            ? ''
                            : t('error_inline_bigger_than_zero'), 
                    operationsHolder: contextHolder, 
                    readerAttribute: "fermenterDays", 
                    name: t('beer_style_days_fermenter_label'), 
                    value: selectedItem, 
                    label: t('beer_style_fermenter_days'), 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    additionalValidation: value =>
                        NumberUtils.isNumber(value) && value > 0
                            ? ''
                          : t('error_inline_bigger_than_zero'), 
                    operationsHolder: contextHolder, 
                    readerAttribute: "packagingDays", 
                    name: t('beer_style_days_packaging_label'), 
                    value: selectedItem, 
                    label: t('beer_style_packaging_days'), 
                    onEnter: this._onEnterPress}
                ),
            ];

            let additionalButtons = [
                {
                    type: 'CHANGE',
                    el: (
                      React.createElement(FormGroupToggle, {
                        operationsHolder: contextHolder, 
                        name: t('beer_style_admin_status_enable_label'), 
                        value: selectedItem, 
                        label: t('beer_style_admin_status_enable_label'), 
                        readerAttribute: "enable"}
                      )
                    )
                },
                {
                    type: 'CHANGE',
                    permission: 'BREWING_ICONS',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('beer_style_admin_set_brewing_icons'), 
                            icon: "subdirectory_arrow_right", 
                            type: "icon", 
                            onClick: this._goToSelectedBeerStyle.bind(
                                this,
                                'brewing'
                            )}
                        )
                    )
                },
                {
                    type: 'CHANGE',
                    permission: 'FERMENTING_ICONS',
                    el: (
                        React.createElement(FormGroupButton, {
                          label: t('beer_style_admin_set_fermenting_icons'), 
                            icon: "subdirectory_arrow_right", 
                            type: "icon", 
                            onClick: this._goToSelectedBeerStyle.bind(
                                this,
                                'fermenter'
                            )}
                        )
                    )
                },
                {
                    type: 'CHANGE',
                    permission: 'PACKAGING_ICONS',
                    el: (
                        React.createElement(FormGroupButton, {
                          label: t('beer_style_admin_set_packaging_icons'), 
                            icon: "subdirectory_arrow_right", 
                            type: "icon", 
                            onClick: this._goToSelectedBeerStyle.bind(
                                this,
                                'packaging'
                            )}
                        )
                    )
                }
                ];
    
            additionalButtons.push({
                type: 'CHANGE',
                permission: 'DUPLICATE',
                el: (
                  React.createElement(FormGroupButton, {
                    label: t('beer_style_admin_duplicate'), 
                    icon: "content_copy", 
                    type: "icon", 
                    onClick: this._onDuplicate.bind(this, contextHolder)}
                  )
                )
            });

            return (
                React.createElement(AdminScaffolding, {
                    isDisabled: isSaving, 
                    moduleName: "ADMIN_BEER_STYLE", 
                    messages: messages, 
                    title: t('beer_style_label_name'), 
                    contextHolder: contextHolder, 
                    value: selectedItem, 
                    fetchItems: this.fetchBeerStyles, 
                    headerFields: formFieldsEl, 
                    onAdd: this._onAddBeerStyle, 
                    onChange: this._onChangeBeerStyle, 
                    onCancel: this._onCancel, 
                    onDelete: this._onDeleteBeerStyle, 
                    additionalButtons: additionalButtons, 
                    breadcrumb: this._getBreadcrumbLinks(), 
                    addEnterKeyDown: this._addEnterKeyDown
                }, 

                    React.createElement(AdminScaffoldingTable, {
                        allowShowDisable: true, 
                        headerActiveFilters: headerActiveFilters, 
                        onRowSelection: this._onRowSelection, 
                        value: selectedItem, 
                        sortByColumn: ['name'], 
                        columnNames: [
                            t('name'),
                            t('beer_style_brewing_icons'),
                            t('beer_style_fermenting_icons'),
                            t('beer_style_packaging_icons')
                        ], 
                        filteredColumns: [
                            'name',
                            'brewingDays',
                            'fermenterDays',
                            'packagingDays'
                        ], 
                        displayAttributes: [
                            {
                                getHTML: this._getWrapperColor
                            },
                            {
                                name: 'styleBeerConfigurationTaskDto',
                                getHTML: this._getStampsIcons.bind(
                                    this,
                                    'brewing'
                                )
                            },
                            {
                                name: 'styleBeerConfigurationTaskDto',
                                getHTML: this._getStampsIcons.bind(
                                    this,
                                    'fermenter'
                                )
                            },
                            {
                                name: 'styleBeerConfigurationTaskDto',
                                getHTML: this._getStampsIcons.bind(
                                    this,
                                    'packaging'
                                )
                            }
                        ]
                    }, 
                        beerStyles
                    )
                )
            );
        }
    }
});

module.exports = BeerStyleAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/BeerStyleAdmin/BeerStyleAdmin.jsx
 **/